import React from 'react';

import { NumberInput, Stack, Text } from '@mantine/core';

import { blockNonInteger, RepsResult } from './types';

interface RepsInputProps {
  value: RepsResult;
  onChange: (value: RepsResult) => void;
  enlarged?: boolean;
}

const RepsInput = ({ value, onChange, enlarged = false }: RepsInputProps): JSX.Element => (
  <Stack spacing={4}>
    <Text size={enlarged ? 'lg' : 'xs'} weight={600} color='dimmed' transform='uppercase'>
      Total Reps
    </Text>
    <NumberInput
      value={value.reps}
      onChange={reps => onChange({ ...value, reps })}
      min={0}
      precision={0}
      inputMode='numeric'
      onKeyDown={blockNonInteger}
      size={enlarged ? 'xl' : 'md'}
    />
  </Stack>
);

export default RepsInput;
